import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'antd';
import {
  ContentWrapper, IndicatorContent,
  IndicatorWrapper, PadContentWrapper,
  PadWrapper, SeatWrapper,
  Wrapper,
} from './styles';
import { StyledParagraph } from '../CustomAntdComponents/Typography';
import { StyledButton } from '../CustomAntdComponents/StyledButton';
import { useRoadSearchStore } from '../../store/roadSearch/roadSearchStore';
import { groupBy, pluralizeText } from '../../utils/helpers';
import steering from '../../assets/images/steering.svg';
import { useI18nContext } from '../../utils/I18n';
import translations from '../../screens/PassengerDetails/translations';

function SeatSelection() {
  const {
    state: { t },
  } = useI18nContext();
  const navigate = useNavigate();
  const [isCompleted, setIsCompleted] = useState(false);
  const [busSize, setBusSize] = useState('');
  const [column, setColumn] = useState(1);
  const [marginalizedSeats, setMarginalizedSeats] = useState<number[]>([]);
  const [doubleMarginalizedSeats, setDoubleMarginalizedSeats] = useState<number[]>([]);
  const [selectedSeats, setSelectedSeats] = useState<AvailableSeat[]>([]);
  const [sortedMapSeats, setSortedMapSeats] = useState<AvailableSeat[][]>([]);
  const [sortedSeats, setSortedSeats] = useState<AvailableSeat[]>([]);
  const { formData: { numberOfAdults }, selectedBus, updateFormData } = useRoadSearchStore();
  const totalPassengers = numberOfAdults;
  const isReturning = selectedBus?.length === 2;
  const activeBus = useMemo(() => {
    return isReturning ? selectedBus[1] : selectedBus[0];
  }, [selectedBus, isReturning]);

  const getSeatStatus = (seat: AvailableSeat) => {
    const findSeat = selectedSeats.find((s) => s.SeatNumber === seat.SeatNumber);
    if (!findSeat) {
      return seat.IsAvailable ? 'available' : 'booked';
    }

    return 'selected';
  };
  const getIsDriverStatus = (seat: AvailableSeat) => seat.Row === 1 && seat.Column === 1;

  const handleSeatSelection = (seat: AvailableSeat) => {
    const findSeat = selectedSeats.find((s) => s.SeatNumber === seat.SeatNumber);

    if (!findSeat && seat.IsAvailable && !isCompleted) {
      setSelectedSeats([...selectedSeats, { ...seat }]);
    } else {
      const newSelections = selectedSeats.filter((s) => s.SeatNumber !== seat.SeatNumber);
      setSelectedSeats([...newSelections]);
    }
  };

  const handleProceed = () => {
    updateFormData({ selectedSeats });
    navigate('/passenger-details/road');
  };

  const getSeatWidth = useCallback(() => {
    const numberOfSeats = activeBus?.Capacity || 0;
    setColumn(activeBus?.Column || 1);

    let size: string;

    if (numberOfSeats >= 53) {
      size = 'large';
    } else if (numberOfSeats >= 12 && numberOfSeats <= 15) {
      size = 'medium';
    } else if (numberOfSeats >= 8 && numberOfSeats <= 12) {
      size = 'medium-s';
    } else {
      size = 'small';
    }
    setBusSize(size);
    const allSort = [];
  }, [activeBus]);

  // eslint-disable-next-line prefer-const
  let allSort = [];

  const displaySeatPosition = (sortSeats) => {
    sortSeats.forEach((rows:any, rowIndex) => {

      let mapSortedSeats = [];

      for (let colIndex = 1; colIndex <= column; colIndex++) {

        const checkRow = rows?.find((item :AvailableSeat) => item.Column === colIndex);
        if (checkRow) {


          mapSortedSeats.push(checkRow);
        } else {
          mapSortedSeats.push({
            IsAvailable: false,
            SeatNumber: 0,
            Price: 0,
            Row: rowIndex + 1,
            Column: colIndex,
          });
        }
      }
      
      allSort.push(mapSortedSeats);
      
    });
    return allSort;
  };

  useEffect(() => {
    setIsCompleted(selectedSeats.length === totalPassengers);
  }, [selectedSeats, totalPassengers]);

  useEffect(() => {
    if (activeBus && activeBus.AvailableSeats) {

      const seats = activeBus.AvailableSeats.sort((a, b) => a.Row - b.Row || parseInt(a.SeatNumber) - parseInt( b.SeatNumber));
      const groupedValue = groupBy(activeBus.AvailableSeats, (seat: AvailableSeat) => seat.Row);
      const groupedSeats = Array.from(groupedValue, ([_, value]) => (
        value));

      // @ts-ignore
      setSortedSeats(seats as unknown as AvailableSeat[]);
      getSeatWidth();
      const checkMappedSeat = displaySeatPosition(groupedSeats);
      // return order[a.code] - order[b.code] || a.counter - b.counter;
      setSortedMapSeats(checkMappedSeat);
      // setSortedSeats(displaySeatPosition(groupedSeats))
    }
  }, [selectedBus, busSize]);

  return (
    <Wrapper>
      <Card>
        <ContentWrapper size={busSize}>
          <IndicatorWrapper>
            <IndicatorContent>
              <SeatWrapper />
              <StyledParagraph type="secondary" size="small" align="center">
                {t(translations).available}
              </StyledParagraph>
            </IndicatorContent>
            <IndicatorContent>
              <SeatWrapper status="booked" />
              <StyledParagraph type="secondary" size="small" align="center">
                {t(translations).booked}
              </StyledParagraph>
            </IndicatorContent>
            <IndicatorContent>
              <SeatWrapper status="blocked" />
              <StyledParagraph type="secondary" size="small" align="center">
                {t(translations).blocked}
              </StyledParagraph>
            </IndicatorContent>
            <IndicatorContent>
              <SeatWrapper status="selected" />
              <StyledParagraph type="secondary" size="small" align="center">
                {t(translations).selected}
              </StyledParagraph>
            </IndicatorContent>
          </IndicatorWrapper>

          <StyledParagraph align="center" padded="true">
            {`${t(translations).seatSelectionText} ${pluralizeText(
              totalPassengers,
              t(translations).passenger,
              t(translations).passengers,
            )}`}
          </StyledParagraph>

          {/* <PadWrapper column={column}>
            {sortedMapSeats.map((seatArr) => seatArr.map((seat, index) => (
              <SeatWrapper
                key={seat.SeatNumber}
                status={getSeatStatus(seat)}
                onClick={() => handleSeatSelection(seat)}
                isEmpty={seat.SeatNumber === 0}
                isDriver={getIsDriverStatus(seat)}
              >
                {getIsDriverStatus(seat) ? <img src={steering} alt="" /> : seat.SeatNumber}
              </SeatWrapper>
            )))}
          </PadWrapper> */}

          <PadContentWrapper>
            {sortedMapSeats.map((seatArr) => (
              <PadWrapper column={column}>
                {seatArr.map((seat) => (
                  <SeatWrapper
                    key={seat.SeatNumber}
                    status={getSeatStatus(seat)}
                    onClick={() => handleSeatSelection(seat)}
                    isEmpty={seat.SeatNumber === "0" && !getIsDriverStatus(seat)}
                    isDriver={getIsDriverStatus(seat)}
                  >
                    {getIsDriverStatus(seat) ? <img src={steering} alt="" /> : seat.SeatNumber}
                  </SeatWrapper>
                ))}

              </PadWrapper>
            ))}
          </PadContentWrapper>
          {/* <PadWrapper column={column}>
            {sortedMapSeats.map((seatArr) => seatArr.map((seat) => (
              <SeatWrapper
                key={seat.SeatNumber}
                status={getSeatStatus(seat)}
                onClick={() => handleSeatSelection(seat)}
                isEmpty={seat.SeatNumber === 0 && !getIsDriverStatus(seat)}
                isDriver={getIsDriverStatus(seat)}
              >
                {getIsDriverStatus(seat) ? <img src={steering} alt="" /> : seat.SeatNumber}
              </SeatWrapper>
            )))}
          </PadWrapper> */}

          <StyledButton type="primary" block size="large" disabled={!isCompleted} onClick={handleProceed}>
            {t(translations).done}
          </StyledButton>
        </ContentWrapper>
      </Card>
    </Wrapper>
  );
}

export default SeatSelection;
